import { QueryDtoOf } from '@40seas/entities/common';
import { FeeDefinition } from '@40seas/entities/fees';

export class FeeDefinitionQueryDto extends QueryDtoOf(FeeDefinition) {}
